import { render, staticRenderFns } from "./ForbiddenAreasReport.vue?vue&type=template&id=67a86875"
import script from "./ForbiddenAreasReport.vue?vue&type=script&lang=js"
export * from "./ForbiddenAreasReport.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenAreasReport.vue?vue&type=style&index=0&id=67a86875&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports